class KoketaWhatsapp extends HTMLElement {
  connectedCallback() {
    const trigger = this.querySelector('[data-whatsapp-trigger]');
    const panel = this.querySelector('[data-whatsapp-panel]');
    const closeButton = this.querySelector('[data-whatsapp-close]');
    if (!trigger || !panel) return;

    const open = () => {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      closeButton?.focus();
    };
    const close = () => {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    };

    trigger.addEventListener('click', () => panel.hidden ? open() : close());
    closeButton?.addEventListener('click', close);
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) close();
    });
  }
}

if (!customElements.get('koketa-whatsapp')) {
  customElements.define('koketa-whatsapp', KoketaWhatsapp);
}
